// 导入解密函数
import { djjdec } from '../crypto/index';
import { HookFun } from './hookFun';

// 将 HookFun 挂载到 window，确保在 eval 中可以访问
if (typeof window !== 'undefined') {
  (window as any).HookFun = HookFun;
}

// 主处理函数
export function pageLoadSetCookie() {
  // 从URL参数中获取token和session_id
  let paramsString = window.location.search;
  if (window.location.hash.includes('?')) {
    paramsString = window.location.hash.split('?')[1];
  }
  const urlParams = new URLSearchParams(paramsString);
  const sessionId = urlParams.get('session_id');
  const wxscanlogin = urlParams.get('wxscanlogin');
  let decryptedSessionId: string | null = null;

  // 设置session_id到Cookie
  if (sessionId && wxscanlogin) {
    // 解密sessionId
    decryptedSessionId = djjdec(sessionId);
    setCookie('session_id', decryptedSessionId, 1);

     const key = 'shuchk_pageLoadSetCookieCallback';
     const storedValue = sessionStorage.getItem(key);
      if (storedValue) {
        try {
           let trimmedValue = storedValue.trim();
           console.log('trimmedValue:', trimmedValue);
           
           // 调试：检查 window.myfunc 是否存在
           console.log('window.myfunc:', (window as any).myfunc);
           console.log('window.HookFun:', (window as any).HookFun);
           
           // 将 PRL.HookFun 替换为 window.HookFun
           trimmedValue = trimmedValue.replace(/\bPRL\.HookFun\b/g, 'window.HookFun');
           console.log('替换后的值:', trimmedValue);
           
           // 使用 eval 在全局上下文执行
           eval(trimmedValue);
        } catch (error) {
          console.error('执行 sessionStorage 中的函数失败:', error);
        }
      }
    // 解析URL，只保留问号左边的部分
    // let newUrl = window.location.href;
    // // 查找问号的位置
    // const questionMarkIndex = newUrl.indexOf('?');
    // if (questionMarkIndex !== -1) {
    //   // 只保留问号左边的部分
    //   newUrl = newUrl.substring(0, questionMarkIndex);
    // }
    // window.location.href = newUrl;
    // console.log('Session ID 已设置到 Cookie:', decryptedSessionId);

  }
  
 
}

// 在 DOMContentLoaded 后执行，确保用户的函数已定义
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pageLoadSetCookie);
  } else {
    // DOM 已加载，延迟执行以确保用户代码先执行
    setTimeout(pageLoadSetCookie, 0);
  }
}


/**
 * 设置cookies
 * @description 设置session_id到Cookie
 * @param {string} name - Cookie名称
 * @param {string} value - Cookie值
 * @param {number} days - 过期天数
 * @param {string} domain - 域名
 * @returns {Promise<boolean>} 
 * @example
 *  setCookie('session_id', 'asdfasdfasfsafsf', 1, '.shuchk.com');
 */
export function setCookie(name: string, value: string, days: number, domain: string = '.shuchk.com') {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/;domain=' + domain;
}

export function getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
